import { BaseModal } from '../base-modal'
import type { ModalSheetProps } from './types'
import { MODAL_SHEET_HEADER_TITLE_ID } from './types'

const ModalSheet = ({ ...props }: ModalSheetProps) => {
  return <BaseModal aria-labelledby={MODAL_SHEET_HEADER_TITLE_ID} {...props} />
}

export default ModalSheet
